import { Box, Stack } from 'braid-design-system';

import TabItem from 'src/views/shared/Tabs/TabItem/TabItem';
import TabSlider from 'src/views/shared/Tabs/TabSlider/TabSlider';

import * as styles from './Tabs.css';

interface Props {
  analyticsOrigin: string;
  tabItems: any[];
  tabRefs: any[];
  children: any;
  tabIndex?: number;
  slider: any;
  onTabClick: (e: Event, index: number) => void;
}

const Tabs = ({
  analyticsOrigin,
  tabItems,
  tabRefs,
  children,
  tabIndex = 0,
  slider,
  onTabClick,
}: Props) => (
  <Stack space="large">
    <Box className={styles.root}>
      <ul className={styles.head}>
        {tabItems.map(({ name, analyticsEvent }: any, index: number) => (
          <TabItem
            key={`tab-item-${name}`}
            tabName={name}
            tabRef={tabRefs[index]}
            isSelected={tabIndex === index}
            analyticsEvent={analyticsEvent}
            analyticsOrigin={analyticsOrigin}
            onClick={(event: Event) => onTabClick(event, index)}
          />
        ))}
      </ul>
      <TabSlider offset={slider.offset} scale={slider.scale} />
    </Box>
    {children[tabIndex]}
  </Stack>
);

export default Tabs;
